import styled from "styled-components"
import styleWithOrgDesign from "QuorumGrassroots/styled-components/connect"

export const Banner = styleWithOrgDesign(styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;

    width: 100%;
    padding: 1rem 1.25rem;

    /* GOTV brand requirement: use organization-based primary palette instead of fixed GOTV blue. */
    background: var(--organization-primary-color-9);
    color: var(--contrasted-organization-primary-color-9);

    border-radius: 12px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.75rem;
    }
`)

export const IconWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 40px;
    height: 40px;
    border-radius: 8px;

    background: rgba(255, 255, 255, 0.2);
    color: var(--contrasted-organization-primary-color-9);

    i {
        font-size: 18px;
        line-height: 1;
    }
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1 1 auto;

    .name {
        font-family: "Roboto", sans-serif;
        font-size: 16px; /* Use px to avoid 10px rem-base shrinking text */
        font-weight: 400;
        line-height: 1.2;
        color: var(--contrasted-organization-primary-color-9);
    }

    .date {
        font-family: "Roboto", sans-serif;
        font-size: 14px; /* Use px to ensure 14px under 10px rem base */
        font-weight: 600;
        line-height: 1.2;
        color: var(--contrasted-organization-primary-color-9);
    }
`

export const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: var(--plum-spacing-xs);

    @media (max-width: 768px) {
        width: 100%;
        justify-content: stretch;
    }
`
